// import React, { useState, useEffect, useRef, Profiler } from "react";
// import axios from "axios";
// import { FaChevronDown, FaChevronUp, FaCommentAlt, FaPaperPlane } from "react-icons/fa";
// import Terms from "../Profile/Food/Terms";
// import Refund from "../Profile/Food/Cancelrefund";
// import { Link } from "react-router-dom";
// import { Scale } from "@mui/icons-material";
// import Registration from "../Profile/Food/Registration";
// import { useNavigate } from "react-router-dom";
// import Foodandbeveragesadvertise from './Foodandbeveragesadvertise';
// import { useLoader } from "../../../context/LoaderProvider.jsx";
// import Foodladingpage from "./Foodladingpage.js";
// import Timings from "../Settingsandcontrolmanagment/Food/Timings.js";

// const Foodbeveragescompany = () => {
//     const [activeTab, setActiveTab] = useState("Profile");
//     const { showLoader, hideLoader } = useLoader();
//     const isMobile = window.innerWidth <= 768;

//     const [orderPosts, setOrderPosts] = useState([]);
//     const [isHovered, setIsHovered] = useState(false);
//     const [subscriptions, setSubscriptions] = useState([]);
//     const [vendorId, setVendorId] = useState(null);


//     const navigate = useNavigate();
//     // const containerHeight = window.innerWidth < 768
//     //     ? '200px'      // Mobile
//     //     : window.innerWidth < 850
//     //         ? '300px'  // Below 850px
//     //         : window.innerWidth < 1350
//     //             ? '405px' // Between 850px and 1350px
//     //             : '500px'; // Desktop

//     // const containerHeight = window.innerWidth < 768
//     //     ? '300px'       // Mobile
//     //     : window.innerWidth < 850
//     //         ? '300px'     // Below 850px
//     //         : window.innerWidth < 1400
//     //             ? '410px'   // Between 850px and 1399px
//     //             : window.innerWidth < 1600
//     //                 ? '410px' // Between 1400px and 1599px
//     //                 : '450px'; // Above 1600px
//     const containerHeight = window.innerHeight > 600
//         ? (
//             window.innerWidth < 768
//                 ? '60vh'       // Mobile - 55% of viewport height
//                 : window.innerWidth < 850
//                     ? '63vh'     // Below 850px - 60% of viewport height
//                     : window.innerWidth < 1400
//                         ? '65vh'   // Between 850px and 1399px - 65% of viewport height
//                         : window.innerWidth < 1600
//                             ? '70vh' // Between 1400px and 1599px - 70% of viewport height
//                             : '75vh'  // Above 1600px - 75% of viewport height
//         )
//         : (
//             window.innerWidth < 768
//                 ? '300px'       // Mobile (small height screens)
//                 : window.innerWidth < 850
//                     ? '300px'     // Below 850px (small height screens)
//                     : window.innerWidth < 1400
//                         ? '410px'   // Between 850px and 1399px (small height screens)
//                         : window.innerWidth < 1600
//                             ? '410px' // Between 1400px and 1599px (small height screens)
//                             : '450px'  // Above 1600px (small height screens)
//         );
//     const handleRedirect = () => {
//         navigate("/subscriptionrenewal");
//     };

//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         if (storedVendorId) {
//             setVendorId(storedVendorId);
//         }
//     }, []);

//     useEffect(() => {
//         const fetchSubscriptions = async () => {
//             try {
//                 showLoader();
//                 const vendorId = localStorage.getItem("vendorId"); // ✅ Retrieve vendorId https://backend.maamaas.com/subscription/subscriptions/user/
//                 const token = localStorage.getItem("authToken");
//                 if (!token || !vendorId) {
//                     // console.warn("Missing token or vendorId");
//                     return;
//                 }

//                 const response = await axios.get(
//                     `https://backend.maamaas.com/subscription/api/get/vendor_subscription/${vendorId}/FOOD_AND_BEVERAGES`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                             "Content-Type": "application/json",
//                         },
//                     }
//                 );


//                 const data = response.data;
//                 if (Array.isArray(data)) {
//                     setSubscriptions(data);
//                 } else if (data && Array.isArray(data.subscriptions)) {
//                     setSubscriptions(data.subscriptions);
//                 } else if (data) {
//                     setSubscriptions([data]);
//                 } else {
//                     setSubscriptions([]);
//                 }
//             } catch (error) {
//                 console.error(
//                     "Failed to fetch subscriptions:",
//                     error.response?.data || error.message
//                 );
//                 setSubscriptions([]);
//             } finally {
//                 hideLoader();
//             }
//         };

//         fetchSubscriptions();
//     }, []);


//     const scrollContainerRef = useRef(null);

//     useEffect(() => {
//         const scrollContainer = scrollContainerRef.current;
//         if (!scrollContainer) return;

//         let interval;

//         const startScrolling = () => {
//             interval = setInterval(() => {
//                 if (!isHovered) {
//                     scrollContainer.scrollTop += 1; // Scroll down smoothly

//                     // Infinite loop logic
//                     if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
//                         scrollContainer.scrollTop = 0; // Reset to top for seamless loop
//                     }
//                 }
//             }, 20); // Adjust speed by changing interval
//         }

//         startScrolling();


//         return () => clearInterval(interval);
//     }, [isHovered]);

//     const scrollRef = useRef(null);

//     useEffect(() => {
//         const container = scrollRef.current;
//         if (!container) return;

//         const scrollSpeed = 1; // px per tick
//         const scrollInterval = 20; // ms
//         let scroll;

//         const startScroll = () => {
//             scroll = setInterval(() => {
//                 container.scrollTop += scrollSpeed;

//                 // When scroll reaches half (original content height), reset to top for seamless loop
//                 if (container.scrollTop >= container.scrollHeight / 2) {
//                     container.scrollTop = 0;
//                 }
//             }, scrollInterval);
//         };

//         startScroll();

//         return () => clearInterval(scroll);
//     }, [orderPosts]);

//     // {=======================overview===============================}
//     const tabContent = {
//         // "POS Billng": <Digialmenubillingspage />,
//         Profile: <Foodladingpage />,
//         Timings : <Timings />,
//         "Documents": <Registration onNext={() => {
//             setActiveTab("Terms And Conditions"); // Use the string key
//         }} />,

//         // "Terms And Conditions": <Terms
//         //     onNext={() => {
//         //         setActiveTab("Cancel/Refund"); // Use the string key
//         //     }}
//         //     onBack={() => { // Example for a back button
//         //         setActiveTab("Registration");
//         //     }}
//         // />,

//         // "Cancel/Refund": <Refund
//         //     onFinish={() => { // Example for a finish button
//         //         setActiveTab("Subscription"); // Go to another tab after finishing
//         //     }}
//         //     onBack={() => {
//         //         setActiveTab("Terms And Conditions");
//         //     }}
//         // />,
//         // ... other tabs

//         // Summary: (
//         //     <div>
//         //         {subscriptions.length === 0 ? (
//         //             <p>No subscriptions found.</p>
//         //         ) : (
//         //             subscriptions.map((sub, index) => (
//         //                 <table key={sub?.id || index} style={tableStyle}>
//         //                     <thead>
//         //                         <tr>
//         //                             <th style={headerStyle}>Field</th>
//         //                             <th style={headerStyle}>Value</th>
//         //                         </tr>
//         //                     </thead>
//         //                     <tbody>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>Vendor ID</td>
//         //                             <td style={cellStyle}>
//         //                                 {sub?.vendorEnquiry?.vendorId || "N/A"}
//         //                             </td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>Application</td>
//         //                             <td style={cellStyle}>
//         //                                 <span
//         //                                     style={{
//         //                                         color: sub?.status ? "green" : "red",
//         //                                         fontWeight: "bold",
//         //                                     }}
//         //                                 >
//         //                                     {sub?.status ? "Approved" : "Pending"}
//         //                                 </span>
//         //                             </td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>Status</td>
//         //                             <td style={cellStyle}>
//         //                                 {/* <span
//         //                                     style={{
//         //                                         color: sub?.status ? "green" : "red",
//         //                                         fontWeight: "bold",
//         //                                     }}
//         //                                 >
//         //                                     {sub?.status ? "Active" : "Inactive"}
//         //                                 </span> */}
//         //                                 <div style={{

//         //                                     display: "flex",
//         //                                     alignItems: "center",
//         //                                     justifyContent: "center",
//         //                                     marginRight: "115px",
//         //                                 }}>
//         //                                     <span
//         //                                         style={{
//         //                                             color: sub?.status ? "green" : "red",
//         //                                             fontWeight: "bold",
//         //                                         }}
//         //                                     >
//         //                                         {sub?.status ? "Active" : "Inactive"}
//         //                                     </span>
//         //                                     <button
//         //                                         onClick={handleRedirect} // ✅ keep only one onClick
//         //                                         style={{
//         //                                             backgroundColor: sub?.status ? "#4CAF50" : "#f44336",
//         //                                             color: "#fff",
//         //                                             border: "none",
//         //                                             borderRadius: "4px",
//         //                                             marginRight: "-120px",
//         //                                             padding: "5px 10px",
//         //                                             cursor: "pointer", // better UX
//         //                                             marginLeft: "20px",
//         //                                         }}
//         //                                     >
//         //                                         Upgrade
//         //                                     </button>
//         //                                 </div>

//         //                             </td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>
//         //                                 Business Verticals
//         //                             </td>
//         //                             <td style={cellStyle}>{sub?.vendorEnquiry?.businessVerticals}</td>

//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>
//         //                                 Remaining Days
//         //                             </td>
//         //                             <td style={cellStyle}>{sub?.remainingDays}</td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>Plan</td>
//         //                             <td style={cellStyle}>{sub?.subscriptionPlan?.planType}</td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>Start Date</td>
//         //                             <td style={cellStyle}>
//         //                                 {sub?.startDate ? sub.startDate.slice(0, 10) : "N/A"}
//         //                             </td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>End Date</td>
//         //                             <td style={cellStyle}>
//         //                                 {sub?.endDate ? sub.endDate.slice(0, 10) : "N/A"}
//         //                             </td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>Company Name</td>
//         //                             <td style={cellStyle}>{sub?.vendorEnquiry?.companyName}</td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>Owner Name</td>
//         //                             <td style={cellStyle}>{sub?.vendorEnquiry?.name}</td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>
//         //                                 Phone Number
//         //                             </td>
//         //                             <td style={cellStyle}>{sub?.vendorEnquiry?.mobileNumber}</td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>Email</td>
//         //                             <td style={cellStyle}>{sub?.vendorEnquiry?.email}</td>
//         //                         </tr>
//         //                         <tr>
//         //                             <td style={{ ...cellStyle, fontWeight: "bold" }}>Pincode</td>
//         //                             <td style={cellStyle}>
//         //                                 {sub?.vendorEnquiry?.pincode || "N/A"}
//         //                             </td>
//         //                         </tr>
//         //                     </tbody>
//         //                 </table>
//         //             ))
//         //         )}
//         //     </div>

//         // ),

//     };

//     return (
//         <>
//             <div>
//                 <style>{`
//         .main-container {
//           padding: 20px;
//           display: flex;
//           flex-direction: column;
         
//         }

//          .tabs-wrapper {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//           margin-left:0px;
// }
// // .left-column {
// //             width: 100%;
// //             padding-right: 140px;
// //             max-height: 700px;
           
// //           }


// /* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
// @media screen and (max-width: 768px) {
//   .tabs-wrapper {
//     margin-left: 0;
    
//   }
// }


//         .tab-buttons {
//           display: flex;
//         //   flex-wrap: wrap;
//           justify-content: center;
//           gap: 10px;
//           margin-top:81px;
//           padding:14px;
         
//         }

//         .tab-button {
//           border: none;
//           border-radius: 10px;
//           width: 126px;
//           height: 40px;
//           background-color: #d9d9d9;
//           color: #000;
//           font-weight: bold;
//           cursor: pointer;
//           transition: background-color 0.3s ease;
//         }

//         .tab-button.active {
//           background-color: #b15cd6;
//         }
// /* TAB CONTENT */
// .tab-content {
//     margin-top: 0px;
//     width: 100%;
//     overflow-x: auto;      /* horizontal scroll visible */
//     overflow-y: scroll;    /* vertical scroll works but hidden */
// }

// /* Hide vertical scrollbar (WebKit browsers) */
// .tab-content::-webkit-scrollbar {
//     width: 1px;    /* hide vertical scrollbar */
//     height: 8px;   /* horizontal scrollbar size */
// }

// .tab-content::-webkit-scrollbar-track {
//     background: #f0f0f0;
// }

// .tab-content::-webkit-scrollbar-thumb {
//     background: #b15cd6;
//     border-radius: 10px;
// }

// /* Hide scrollbar for Firefox */
// .tab-content {
//     scrollbar-width: none;   /* hides vertical scrollbar */
// }

          
//     }

//         .sidebar {
//           margin-top: 30px;
//           max-height: 600px;
//           overflow-y: auto;
//         }

//         .card {
//           width: 100%;
//           max-width: 300px;
//           height: 120px;
//           background: #ccc;
//           border-radius: 8px;
//           box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
//           margin: 10px auto;
//           position: relative;
//           padding: 10px;
//         }

//         .card h5, .card p {
//           color: white;
//           margin: -18 !imortanant;
//         }

        

        
//         @media (min-width: 768px) {
//           .main-container {
//             flex-direction: row;
//             justify-content: space-between;
//           }

          

//           .left-column {
//             width: 100%;
//             padding-right: 95px;
//             max-height: 700px;
           
//           }

//           .right-column {
//             width: 30%;
//             position: sticky;
//             top: -30px;
//             max-height: 700px;
//             overflow-y: auto;
//           }

//           .card {
//             margin-left: 0;
//           }
//             .tabs-wrapper{
//             margin-left:none

//             }
//             .profile-mobilescroll{
//             margin-top:119px!important;
//             }

//         }

//         /* Hide native scrollbars */
//         .sidebar::-webkit-scrollbar,
//         .left-column::-webkit-scrollbar {
//           width: 0px;
//           background: transparent;
//         }
//           @media(max-width : 991px){
//           .hideits{
//           display:none !important;}
//           }
//       `}</style>

//                 {/* Main Layout */}
//                 <div className="container-fluid company-mobile-data"
//                     style={{
//                         height: "500px"
//                     }}
//                 >
//                     <div className="row">
//                         <div className="col-lg-2"></div>
//                         <div className="col-lg-7">

//                             <p
//                                 className="breadcrumb maamaas-home-bredcum"
//                                 style={{
//                                     position: "fixed",
//                                     top: window.innerWidth <= 425 ? " 60px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "64px" : "75px",
//                                     left: "2vw",
//                                     width: "100%",
//                                     backgroundColor: "#fff",
//                                     zIndex: 1000,
//                                     padding: "10px 0",
//                                     fontSize: isMobile ? "16px" : "18px",
//                                     fontWeight: isMobile ? "normal" : "bold",
//                                     textAlign: "center",
//                                     margin: 0,
//                                 }}
//                             >
//                                 {/* <Link
//                                     to="/Newmainlandingpage"
//                                     style={{
//                                         color: "#A055B0",
//                                         fontWeight: "bold",
//                                         textDecoration: "none",
//                                     }}
//                                 >
//                                     Home
//                                 </Link> */}

//                                 {/* <span className="separator"> &gt; </span> */}
//                                 <Link
//                                     to="/foodladingpage"
//                                     style={{
//                                         color: "purple",
//                                         fontWeight: "bold",
//                                         textDecoration: "none",
//                                     }}
//                                 >
//                                     Food & Beverages

//                                 </Link>

//                                 <span className="separator"> &gt; </span>
//                                 <Link

//                                     style={{
//                                         color: "purple",
//                                         fontWeight: "bold",
//                                         textDecoration: "none",
//                                     }}
//                                 >
//                                     Profile
//                                 </Link>
//                             </p>



//                             {/* Left Section */}
//                             <div className="profile-mobilescroll">
//                                 <div >

//                                     <div className="tab-buttons" style={{ flexWrap: window.innerWidth <= 562 ? "wrap" : "nowrap", marginTop:"40px" }}>
//                                         {Object.keys(tabContent).map((label) => (
//                                             <button
//                                                 key={label}
//                                                 className={`tab-button ${activeTab === label ? "active" : ""}`}
//                                                 onClick={() => setActiveTab(label)}
//                                             >
//                                                 {label}
//                                             </button>
//                                         ))}
//                                     </div>
//                                     <div
//                                         className="tab-content "
//                                         style={{

//                                             height: containerHeight,
//                                             overflowX: "auto",
//                                             overflowY: "scroll",
//                                             // maxWidth: '944px',
//                                         }}
//                                     >
//                                         {tabContent[activeTab]}
//                                     </div>
//                                 </div>
//                             </div>


//                         </div>
//                         <div className="col-lg-3  hideits">
//                             <Foodandbeveragesadvertise />
//                         </div>
//                     </div>
//                 </div>
//             </div >
//         </>
//     );
// };


// const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     marginBottom: "30px",
//     border: "1px solid #ddd",
// };

// const headerStyle = {
//     backgroundColor: "#b15dc6",
//     padding: "10px",
//     border: "1px solid #ccc",
//     textAlign: "Center",
//     fontWeight: "bold"
// };

// const cellStyle = {
//     padding: "10px",
//     border: "1px solid #ccc",
// };

// const deleteButtonStyle = {
//     backgroundColor: "red",
//     color: "white",
//     border: "none",
//     padding: "5px 10px",
//     cursor: "pointer",
//     borderRadius: "5px",
// };
// const iconButtonStyle = {
//     backgroundColor: "transparent",
//     border: "none",
//     cursor: "pointer",
//     fontSize: "18px",
//     marginRight: "8px",
//     color: "#333",
// };

// const modalOverlayStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0,0,0,0.5)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 1000,
// };

// const modalContentStyle = {
//     backgroundColor: "#fff",
//     padding: "20px",
//     borderRadius: "10px",
//     minWidth: "300px",
//     boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
// };




// export default Foodbeveragescompany;






import React, { useState, useEffect, useRef, Profiler } from "react";
import axios from "axios";
import { FaChevronDown, FaChevronUp, FaCommentAlt, FaPaperPlane } from "react-icons/fa";
import Terms from "../Profile/Food/Terms";
import Refund from "../Profile/Food/Cancelrefund";
import { Link } from "react-router-dom";
import { Scale } from "@mui/icons-material";
import Registration from "../Profile/Food/Registration";
import { useNavigate } from "react-router-dom";
import Foodandbeveragesadvertise from './Foodandbeveragesadvertise';
import { useLoader } from "../../../context/LoaderProvider.jsx";
import Foodladingpage from "./Foodladingpage.js";
import Timings from "../Settingsandcontrolmanagment/Food/Timings.js";

const Foodbeveragescompany = () => {
    const [activeTab, setActiveTab] = useState("Profile");
    const { showLoader, hideLoader } = useLoader();
    const isMobile = window.innerWidth <= 768;

    const [orderPosts, setOrderPosts] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);
    const [vendorId, setVendorId] = useState(null);


    const navigate = useNavigate();
    // const containerHeight = window.innerWidth < 768
    //     ? '200px'      // Mobile
    //     : window.innerWidth < 850
    //         ? '300px'  // Below 850px
    //         : window.innerWidth < 1350
    //             ? '405px' // Between 850px and 1350px
    //             : '500px'; // Desktop

    // const containerHeight = window.innerWidth < 768
    //     ? '300px'       // Mobile
    //     : window.innerWidth < 850
    //         ? '300px'     // Below 850px
    //         : window.innerWidth < 1400
    //             ? '410px'   // Between 850px and 1399px
    //             : window.innerWidth < 1600
    //                 ? '410px' // Between 1400px and 1599px
    //                 : '450px'; // Above 1600px
    const containerHeight = window.innerHeight > 600
        ? (
            window.innerWidth < 768
                ? '60vh'       // Mobile - 55% of viewport height
                : window.innerWidth < 850
                    ? '63vh'     // Below 850px - 60% of viewport height
                    : window.innerWidth < 1400
                        ? '65vh'   // Between 850px and 1399px - 65% of viewport height
                        : window.innerWidth < 1600
                            ? '70vh' // Between 1400px and 1599px - 70% of viewport height
                            : '75vh'  // Above 1600px - 75% of viewport height
        )
        : (
            window.innerWidth < 768
                ? '300px'       // Mobile (small height screens)
                : window.innerWidth < 850
                    ? '300px'     // Below 850px (small height screens)
                    : window.innerWidth < 1400
                        ? '410px'   // Between 850px and 1399px (small height screens)
                        : window.innerWidth < 1600
                            ? '410px' // Between 1400px and 1599px (small height screens)
                            : '450px'  // Above 1600px (small height screens)
        );
    const handleRedirect = () => {
        navigate("/subscriptionrenewal");
    };

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        if (storedVendorId) {
            setVendorId(storedVendorId);
        }
    }, []);

    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                showLoader();
                const vendorId = localStorage.getItem("vendorId"); // ✅ Retrieve vendorId https://backend.maamaas.com/food/subscriptions/user/
                const token = localStorage.getItem("authToken");
                if (!token || !vendorId) {
                    // console.warn("Missing token or vendorId");
                    return;
                }

                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/get/vendor_subscription/${vendorId}/FOOD_AND_BEVERAGES`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );


                const data = response.data;
                if (Array.isArray(data)) {
                    setSubscriptions(data);
                } else if (data && Array.isArray(data.subscriptions)) {
                    setSubscriptions(data.subscriptions);
                } else if (data) {
                    setSubscriptions([data]);
                } else {
                    setSubscriptions([]);
                }
            } catch (error) {
                console.error(
                    "Failed to fetch subscriptions:",
                    error.response?.data || error.message
                );
                setSubscriptions([]);
            } finally {
                hideLoader();
            }
        };

        fetchSubscriptions();
    }, []);


    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1; // Scroll down smoothly

                    // Infinite loop logic
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0; // Reset to top for seamless loop
                    }
                }
            }, 20); // Adjust speed by changing interval
        }

        startScrolling();


        return () => clearInterval(interval);
    }, [isHovered]);

    const scrollRef = useRef(null);

    useEffect(() => {
        const container = scrollRef.current;
        if (!container) return;

        const scrollSpeed = 1; // px per tick
        const scrollInterval = 20; // ms
        let scroll;

        const startScroll = () => {
            scroll = setInterval(() => {
                container.scrollTop += scrollSpeed;

                // When scroll reaches half (original content height), reset to top for seamless loop
                if (container.scrollTop >= container.scrollHeight / 2) {
                    container.scrollTop = 0;
                }
            }, scrollInterval);
        };

        startScroll();

        return () => clearInterval(scroll);
    }, [orderPosts]);

    // {=======================overview===============================}
    const tabContent = {
        // "POS Billng": <Digialmenubillingspage />,
        Profile: <Foodladingpage />,
        Timings: <Timings />,
        Registration: <Registration onNext={() => {
            setActiveTab("Terms And Conditions"); // Use the string key
        }} />,


        // ... other tabs



    };

    return (
        <>
            <div>
                <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
         
        }

         .tabs-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
}
// .left-column {
//             width: 100%;
//             padding-right: 140px;
//             max-height: 700px;
           
//           }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;
    
  }
}


        .tab-buttons {
          display: flex;
        //   flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:81px;
          padding:14px;
         
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: 126px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }
/* TAB CONTENT */
.tab-content {
    margin-top: 0px;
    width: 100%;
    overflow-x: auto;      /* horizontal scroll visible */
    overflow-y: scroll;    /* vertical scroll works but hidden */
}

/* Hide vertical scrollbar (WebKit browsers) */
.tab-content::-webkit-scrollbar {
    width: 1px;    /* hide vertical scrollbar */
    height: 8px;   /* horizontal scrollbar size */
}

.tab-content::-webkit-scrollbar-track {
    background: #f0f0f0;
}

.tab-content::-webkit-scrollbar-thumb {
    background: #b15cd6;
    border-radius: 10px;
}

/* Hide scrollbar for Firefox */
.tab-content {
    scrollbar-width: none;   /* hides vertical scrollbar */
}

          
    }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }

          

          .left-column {
            width: 100%;
            padding-right: 95px;
            max-height: 700px;
           
          }

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapper{
            margin-left:none

            }
            .profile-mobilescroll{
            margin-top:119px!important;
            width:62vw !important;
            margin-left: -1vw !important;

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
          @media(max-width : 991px){
          .hideits{
          display:none !important;}
          }
      `}</style>

                {/* Main Layout */}
                <div className="container-fluid company-mobile-data"
                    style={{
                        height: "500px"
                    }}
                >
                    <div className="row">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-7">

                            <p
                                className="breadcrumb maamaas-home-bredcum"
                                style={{
                                    position: "fixed",
                                    top: window.innerWidth <= 425 ? " 60px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "64px" : "75px",
                                    left: "2vw",
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    zIndex: 1000,
                                    padding: "10px 0",
                                    fontSize: isMobile ? "16px" : "18px",
                                    fontWeight: isMobile ? "normal" : "bold",
                                    textAlign: "center",
                                    margin: 0,
                                }}
                            >
                                {/* <Link
                                    to="/Newmainlandingpage"
                                    style={{
                                        color: "#A055B0",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Home
                                </Link> */}

                                {/* <span className="separator"> &gt; </span> */}
                                <Link
                                    to="/foodladingpage"
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Food & Beverages

                                </Link>

                                <span className="separator"> &gt; </span>
                                <Link

                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Profile
                                </Link>
                            </p>



                            {/* Left Section */}
                            <div className="profile-mobilescroll">
                                <div >

                                    <div className="tab-buttons" style={{ flexWrap: window.innerWidth <= 562 ? "wrap" : "nowrap", marginTop: "40px" }}>
                                        {Object.keys(tabContent).map((label) => (
                                            <button
                                                key={label}
                                                className={`tab-button ${activeTab === label ? "active" : ""}`}
                                                onClick={() => setActiveTab(label)}
                                            >
                                                {label}
                                            </button>
                                        ))}
                                    </div>
                                    <div
                                        className="tab-content "
                                        style={{

                                            height: containerHeight,
                                            overflowX: "auto",
                                            overflowY: "scroll",
                                            // maxWidth: '944px',
                                        }}
                                    >
                                        {tabContent[activeTab]}
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div className="col-lg-3  hideits">
                            <Foodandbeveragesadvertise />
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};


const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "30px",
    border: "1px solid #ddd",
};

const headerStyle = {
    backgroundColor: "#b15dc6",
    padding: "10px",
    border: "1px solid #ccc",
    textAlign: "Center",
    fontWeight: "bold"
};

const cellStyle = {
    padding: "10px",
    border: "1px solid #ccc",
};

const deleteButtonStyle = {
    backgroundColor: "red",
    color: "white",
    border: "none",
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: "5px",
};
const iconButtonStyle = {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "18px",
    marginRight: "8px",
    color: "#333",
};

const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
};

const modalContentStyle = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    minWidth: "300px",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
};




export default Foodbeveragescompany;
